import { Pipe, PipeTransform } from '@angular/core';

import { IPbisType } from 'libs/domain';
import { PbisCategory } from 'libs/shared';

import { BehaviorManagerColors } from '../../../constants';

@Pipe({ name: 'getTileColor' })
export class BmDashboardTileColorsPipe implements PipeTransform {
  transform(item, type: 'behaviorType' | 'consequence' | 'automation'): string {
    if (item.iconColor) return item.iconColor;
    if (type === 'behaviorType' || type === 'consequence') {
      const pbisType = item as IPbisType;
      return pbisType.categoryId === PbisCategory.PRAISE
        ? BehaviorManagerColors.PRAISE
        : BehaviorManagerColors.GUIDANCE;
    }
    if (type === 'automation') return BehaviorManagerColors.AUTOMATION;
  }
}
